import React from 'react';
import { Handle, Position } from 'reactflow';
import { Camera, Upload } from 'lucide-react';

const ImageAnalysisNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-purple-200 node-image-analysis">
      <div className="flex items-center">
        <Camera className="w-4 h-4 text-purple-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-purple-800">Image Analysis</div>
          <div className="text-sm text-gray-600">
            {data.config?.analysisType || 'Analyze educational images'}
          </div>
          <div className="text-xs text-purple-600">
            Grade: {data.config?.grade || '5'} • {data.config?.language || 'English'}
          </div>
        </div>
      </div>
      
      <div className="mt-2 flex items-center justify-center">
        <Upload className="w-3 h-3 text-purple-400 mr-1" />
        <span className="text-xs text-purple-500">Upload image to analyze</span>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-purple-500 border-2 border-white"
      />
    </div>
  );
};

export default ImageAnalysisNode;